module.exports = __webpack_public_path__ + "img/202206-xl.6cef3dd1.png";